var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-text prop",
    class: _vm.propClasses,
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('label', {
    staticClass: "inp-label",
    attrs: {
      "for": _vm._uid,
      "title": _vm.prop
    }
  }, [_vm._v(_vm._s(_vm.niceProp))]), _vm._v(" "), _c(_vm.renderType, {
    tag: "component",
    attrs: {
      "id": _vm._uid,
      "focus": _vm.hasPropFocus,
      "value": _vm.fragment[_vm.prop]
    },
    on: {
      "focus": _vm.propFocus,
      "input": function($event) {
        _vm.$set(_vm.fragment, _vm.prop, $event)
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fe3f3bc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prop.vue
// module id = 87
// module chunks = 1